// extracted by mini-css-extract-plugin
export default {"title":"RadioQuestion_title__v3YOl","optional":"RadioQuestion_optional__VOUCK","radio":"RadioQuestion_radio__gCnRz"};